
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparecrmprices",
      function () {
        return require("private-next-pages/comparecrmprices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparecrmprices"])
      });
    }
  